//
//  DocumentationEnvironment.ts
//  Supernova SDK
//
//  Created by Jiri Trecak.
//  Copyright © 2021 Supernova. All rights reserved.
//
// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: - Documentation environment enum
export var DocumentationEnvironment;
(function (DocumentationEnvironment) {
    DocumentationEnvironment["live"] = "Live";
    DocumentationEnvironment["preview"] = "Preview";
})(DocumentationEnvironment || (DocumentationEnvironment = {}));
